// B84: normaliza texto para búsqueda insensible a acentos/diacríticos y
// mayúsculas. "preñada", "PREÑADA" y "prenada" colapsan al mismo término, de
// modo que el finquero que escribe "prenada" (sin ñ) igual matchea "Novilla
// preñada". NFD descompone la letra acentuada en base + marca combinante y el
// replace elimina el diacrítico (la ñ → n); los dígitos y guiones de los tags
// (ej. "CR-053") no se tocan.
export function normalizeText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}
